import { ReactNode } from 'react';
import { ChatbotProvider } from '@components/Chatbot/context/ChatbotContext';
import { PostHogProvider } from '@posthog/react' 
import posthog from '@libs/posthog';

interface ProvidersProps {
  children: ReactNode;
}

const Providers = ({ children }: ProvidersProps) => {
  return (
    <PostHogProvider client={posthog}>
      <ChatbotProvider>
          {children}
      </ChatbotProvider>
    </PostHogProvider>
  );
};

export default Providers;

